import { createContext, useContext } from 'react'

/**
 * Lets a screen put a refresh button in the shared `Header` without threading a prop through
 * every child that renders one.
 *
 * The stock item editor (`EditProducts`) is a tab host: each tab is a separate component that
 * renders its OWN `<Header>` and owns its own API calls. So there is no single header element the
 * host can add a button to. Instead the host publishes `{ onRefresh, refreshing }` here and
 * `Header` renders the button whenever the context is present — which is only inside that dialog,
 * so every other `Header` in the app is untouched.
 *
 * `onRefresh` is expected to reload whatever the ACTIVE tab shows.
 */
const HeaderRefreshContext = createContext(null)

export const HeaderRefreshProvider = HeaderRefreshContext.Provider

/** `{ onRefresh, refreshing }` when a host offers refresh, otherwise `null`. */
export const useHeaderRefresh = () => useContext(HeaderRefreshContext)

export default HeaderRefreshContext
